import { CopyButton } from "@vega-core/components/Buttons/CopyButton/CopyButton";

/** A label/value row with a copy affordance, as shown in the docs modal. */
export const CredentialRow = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => (
  <div className="flex items-center justify-between gap-4 py-2">
    <span className="body-base-medium text-text/secondary whitespace-nowrap shrink-0">
      {label}
    </span>
    <span className="flex items-center gap-1 min-w-0">
      <span className="body-base-regular truncate">{value}</span>
      <CopyButton text={value} />
    </span>
  </div>
);
